import { IonModal } from '@ionic/react'
import React from 'react'
import './MoreTimesModal.scss'

interface IModalProps {
  title?: string;
  des?: string;
  children?: any;
  reject?: () => void;
  resolve?: () => void;
}

const ResultAlert: React.FC<IModalProps> = (props: IModalProps) => {
  const { title, des, reject, resolve, children } = props
  return (
    <IonModal
      cssClass='more-time-modal'
      isOpen
      onDidDismiss={reject}
    >
      <div className='modal-content'>
        <i className='iconfont icon-close' onClick={reject}></i>
        {
          title &&
            <div className='title'>{title}</div>
        }
        {
          des &&
            <div className='des-main'>{des}</div>
        }
        <div className='main'>{children}</div>
      </div>
    </IonModal>
  )
}

export default ResultAlert
